import { render, staticRenderFns } from "./UserSearchModal.vue?vue&type=template&id=47f5ac59&"
import script from "./UserSearchModal.vue?vue&type=script&lang=js&"
export * from "./UserSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./UserSearchModal.vue?vue&type=style&index=0&id=47f5ac59&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports